export const GET_PRQ_INITIATED = 'GET_PRQ_INITIATED';
export const GET_PRQ_SUCCESS = 'GET_PRQ_SUCCESS';
export const GET_PRQ_FAILURE = 'GET_PRQ_FAILURE';
export const GET_PRQ_TEMP_CLEAR = 'GET_PRQ_TEMP_CLEAR';
export const GET_PRS_INITIATED = 'GET_PRS_INITIATED';
export const GET_PRS_SUCCESS = 'GET_PRS_SUCCESS';
export const GET_PRS_FAILURE = 'GET_PRS_FAILURE';
export const GET_PRS_TEMP_CLEAR = 'GET_PRS_TEMP_CLEAR';
